import AppCustomContext from '@providers/AppCustomProvider/context/AppCustomContext';
import { useContext } from 'react';

function useAppCustom() {
  const { response } = useContext(AppCustomContext);
  const {
    main, membership, shop, items, item, payment, orderLog, coupon,
  } = response;
  const useMainBanner = main.bannerPositions.includes('BANNER_1');
  const useSecondBanner = main.bannerPositions.includes('BANNER_2');
  const useThirdBanner = main.bannerPositions.includes('BANNER_3');
  const logo = main.useBrandLogo ? main.brandLogoImage : undefined;
  const useQuickMenu = main.mainFeature === 'QUICK_ORDER';
  const useRecommend = main.useRecommendedItems;
  const { navigationItems, navigationCenterIcon } = main;

  const { shopImageShape } = shop;
  const useAddress = shop.components.includes('ADDRESS');
  const usePhoneNumber = shop.components.includes('PHONE_NUMBER');
  const useHashtag = shop.components.includes('HASHTAG');

  const useExternalCouponInGift = membership.useCouponButton
      && coupon.externalCouponUsePage === 'GIFT';

  const useExternalCouponInCoupon = membership.useCouponButton
  && coupon.externalCouponUsePage === 'COUPON';

  return {
    main: {
      useMainBanner,
      useSecondBanner,
      useThirdBanner,
      logo,
      useQuickMenu,
      useRecommend,
      navigationItems,
      navigationCenterIcon,
    },
    popupType: response.popupBanner.popupBannerType,
    membership,
    shop: {
      shopImageShape,
      useAddress,
      usePhoneNumber,
      useHashtag,
    },
    items,
    item,
    payment,
    orderLog,
    coupon: {
      useExternalCouponInCoupon,
      useExternalCouponInGift,
      couponButtonText: membership.couponButtonText,
    },
  };
}

export default useAppCustom;
